import StoreLayout from '../../layouts/StoreLayout.vue'
import brand from '@/brand'

// Koreniny checkout: the cart, then one page with contact, delivery and payment.
// The old step URLs of the shared checkout lead to that page.
export default [
  {
    path: '/checkout',
    component: StoreLayout,
    children: [
      {
        path: '',
        redirect: '/checkout/cart'
      },
      {
        path: 'cart',
        name: 'checkout.cart',
        component: () => import('../../views/checkout/CartView.vue'),
        meta: {
          title: `Nákupný košík - ${brand.siteName}`,
          requiresCart: true
        }
      },
      {
        path: 'details',
        name: 'checkout.details',
        component: () => import('../../views/checkout/CheckoutView.vue'),
        meta: {
          title: `Pokladňa - ${brand.siteName}`,
          requiresCart: true
        }
      },
      { path: 'personal-info', redirect: '/checkout/details' },
      { path: 'shipping-payment', redirect: '/checkout/details' },
      { path: 'review', redirect: '/checkout/details' },
      {
        path: 'payment-return/:orderNumber',
        name: 'checkout.payment-return',
        component: () => import('../../views/checkout/PaymentReturnView.vue'),
        meta: {
          title: `Overenie platby - ${brand.siteName}`
        }
      },
      {
        path: 'thank-you/:orderNumber?',
        name: 'checkout.thank-you',
        component: () => import('../../views/checkout/ThankYouView.vue'),
        meta: {
          title: `Ďakujeme za objednávku - ${brand.siteName}`
        }
      }
    ]
  }
]
